import Workflow from './workflow'

const cards = {
  workflow: { component: Workflow }
}

export default cards
